import { PHeadline } from '@porsche-design-system/components-react'
import React from 'react'

import { ReportingContext } from '../../../../utils/Context/ReportingContext'
import { headlinesDepartmentList } from '../../../../utils/ratingService'
import Panel from '../../../Panel/Panel'
import TableWithAction from '../TableWithAction/TableWithAction'

type DataSorting = {
  additionalInformation: any
  col0: string
  col1: string
  col2: string
  col3: string
}

type Props = {
  content: DataSorting[]
  loading: boolean
  team?: boolean
}

const TableDepartment: React.FC<Props> = ({ content, loading, team = false }) => {
  const {
    setChosenDepartment,
    setDepartmentButton,
    filter,
    setFilter,
    setShowTeamDepartmentList,
    setShowDepartmentList,
    setContentHeader,
    setResetParams
  } = React.useContext(ReportingContext)

  const [data, setData] = React.useState(content)

  const rowClickHandler = (item: any) => {
    const addInfo = team ? '' : '*'
    setFilter({ ...filter, department: [item.col0 + addInfo] })
    setContentHeader(item.col0)
    setChosenDepartment(item.col0)
    setDepartmentButton(item.col0)
    setShowTeamDepartmentList(!team)
    setShowDepartmentList(false)
    setResetParams(true)
  }

  React.useEffect(() => {
    setData(content)
  }, [content])

  React.useEffect(() => {
    if (loading) {
      setData([])
    }
  }, [loading])

  return (
    <>
      <PHeadline variant='headline-5'>Abteilungen</PHeadline>
      <Panel withMargin withPadding>
        <TableWithAction
          caption='Abteilungen'
          content={data}
          headlines={headlinesDepartmentList}
          loading={loading}
          rowClicker={rowClickHandler}
        />
      </Panel>
    </>
  )
}

export default React.memo(TableDepartment)
